import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Card, HStack, ListRow, renderListRows } from '@tq/ui-components';

import { Comment, Consultation } from 'types';
import { CommentTypeTags } from './CommentTypeTags';
import { useViewComment } from './hooks';
import { useFormatLocaleDate } from 'config/DateFormats/useFormatLocaleDate';

export interface CommentsMobileCardProps {
  consultation?: Consultation;
  comment: Comment;
}
export const CommentsMobileCard: React.FC<CommentsMobileCardProps> = ({
  consultation,
  comment,
}) => {
  const { t } = useTranslation('case_details_comments');
  const formatLocaleDate = useFormatLocaleDate();

  const onViewComment = useViewComment();
  return (
    <Card w='100%' p={4} data-testid='comment-mobile-card'>
      <HStack alignItems='start' justifyContent='space-between'>
        <ListRow width='70%' listItemColumns='40% 60%'>
          {renderListRows(
            [
              {
                label: t('published', 'Published'),
                value: formatLocaleDate(comment.datePublished),
              },
              {
                label: t('name', 'Name'),
                value: comment.name,
              },
            ],
            { mb: 2 }
          )}
          {renderListRows([
            {
              label: t('type', 'Type'),
              renderValue: () => <CommentTypeTags comment={comment} />,
            },
          ])}
        </ListRow>
        {comment?.documents?.length && (
          <Button
            variant='secondary'
            size='sm'
            onClick={() => onViewComment(comment, consultation)}
          >
            {t('view', 'View')}
          </Button>
        )}
      </HStack>
    </Card>
  );
};
